import React, { useEffect } from 'react';

/**
 * MobileOptimization component handles mobile-specific logic and enhancements.
 */
export const MobileOptimization: React.FC = () => {
  useEffect(() => {
    const root = document.documentElement;
    const viewport = window.visualViewport;
    let animationFrame = 0;

    // Keep fixed mobile surfaces aligned with the part of the page that is
    // actually visible when browser chrome or the software keyboard changes.
    const updateViewport = () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(() => {
        const layoutHeight = window.innerHeight;
        const visualHeight = viewport?.height ?? layoutHeight;
        const visualOffsetTop = viewport?.offsetTop ?? 0;
        const keyboardInset = Math.max(0, layoutHeight - visualHeight - visualOffsetTop);

        root.style.setProperty('--vh', `${layoutHeight * 0.01}px`);
        root.style.setProperty('--mobile-visual-viewport-height', `${visualHeight}px`);
        root.style.setProperty('--mobile-visual-viewport-top', `${visualOffsetTop}px`);
        root.style.setProperty('--mobile-keyboard-inset', `${keyboardInset}px`);
        root.dataset.mobileKeyboardOpen = keyboardInset > 80 ? 'true' : 'false';
      });
    };

    updateViewport();
    window.addEventListener('resize', updateViewport, { passive: true });
    window.addEventListener('orientationchange', updateViewport, { passive: true });
    viewport?.addEventListener('resize', updateViewport, { passive: true });
    viewport?.addEventListener('scroll', updateViewport, { passive: true });

    return () => {
      window.cancelAnimationFrame(animationFrame);
      window.removeEventListener('resize', updateViewport);
      window.removeEventListener('orientationchange', updateViewport);
      viewport?.removeEventListener('resize', updateViewport);
      viewport?.removeEventListener('scroll', updateViewport);
      root.style.removeProperty('--mobile-visual-viewport-height');
      root.style.removeProperty('--mobile-visual-viewport-top');
      root.style.removeProperty('--mobile-keyboard-inset');
      delete root.dataset.mobileKeyboardOpen;
    };
  }, []);

  return null;
};
